import { BWICS } from '@/creditflowresearch/domain/BondType';

export default {
  getFisightHomePage: () => ({
    title: 'FINSIGHT',
    description: 'Explore global fixed income new issue pricing or streamline your capital market and corporate finance workflows with our award winning services.',
  }),
  getAbout: () => ({
    title: 'About Us',
    description: "We're an award-winning technology platform for financial institutions that provides unparalleled visibility with actionable insights into capital markets.",
  }),
  getCareers: () => ({
    title: 'Careers With FINSIGHT | Explore Our Open Positions',
    description: "We're looking for creative, self-motivated people who value an entrepreneurial environment and are committed to excellence. Explore our open positions here.",
  }),
  getCompliance: () => ({
    title: 'Our Compliance Policy',
    description: 'An overview of our Compliance Policy.',
  }),
  getHipaaCompliance: () => ({
    title: 'HIPAA Compliance at Finsight',
    description: 'Secure handling of Protected Health Information within DealVDR.',
  }),
  getContactUs: () => ({
    title: 'Contact Us',
    description: 'Send us your questions or comments through this page or contact our fanatical 24x7 support via phone or email.',
  }),
  getOurSolutions: () => ({
    title: 'Solutions By FINSIGHT | Digital Tools For Financial Insights',
    description: 'We offer a suite of best-in-class applications that streamline your workflow, reduce costs & provide unparalleled visibility into your transaction process.',
  }),
  getPrivacyPolicy: () => ({
    title: 'Privacy Policy',
    description: "We're committed to safeguarding your privacy online. Visit this page to view our Privacy Policy.",
  }),
  getSecurityPolicy: () => ({
    title: 'Our Security Policy',
    description: 'Visit this page to read our Security Policy.',
  }),
  getTermsOfUse: () => ({
    title: 'Terms of Use',
    description: 'By accessing or using our Sites, you agree to be bound by the Terms stated here. Please read these Terms carefully and contact us if you have any questions.',
  }),
  getBwicsInventory: (bondType, assetClassAbbreviation) => ({
    title: `Fixed Income ${ assetClassAbbreviation } ${ bondType === BWICS ? 'BWICS' : 'Inventories' }`,
    description: 'Supercharge your ABS BWIC & Inventory discovery process. Seamlessly explore BWICS & Inventory from participating dealers.',
  }),
};
